import React from 'react';
import styles from './pay-modal.css';
import ReactModal from 'react-modal';
import QRcode from 'qrcode.react';
import moment from 'moment';
import {createOrder, orderStatus,inquiryCode} from '../../api/order';
import message from '../message/message.jsx';
import bindAll from "lodash.bindall";
import vipImg from "./vip.png";
import gou from "./gou.png";
import wxpay from "./wxpay.png";
import phone from "./phone.png";

import FullScreen from '../login-reg-modal/FullScreen.jsx';
import ModalClass from '../modal/modal-manager.jsx';
import {vipmember} from '../login-reg-modal/data'

let timer = null
class VipModal extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'createOrders',
            'getOrderStatus',
            'closeOrder',
            'editCode',
            'verifyCode',
            'vipMember'
        ]);
        this.state = {
            goodsInfo: {},
            payStatus: false,
            payNum: 0,
            discountCode:null,
            vipPrice:0
        }
    }

    componentDidMount() {
        this.createOrders()
    }
    // componentWillUnmount() {
    //     event.removeListener(EVENTS.STEP_ABORT, this.close);
    // }

    createOrders(code) {
        const {payNum} = this.state
        createOrder({
            goods_id: 1,
            code:code?code:null
        }, {quiet: true}).then((res) => {
            if (res) {
                this.setState({goodsInfo: res,vipPrice:res.pay_amt});
                if (payNum !== 3) {
                    this.getOrderStatus(res.id);
                }
            }
        })
    }

    getOrderStatus(id) {
        orderStatus({
            id: id
        }, {quiet: true}).then((res) => {
            if (res) {
                if (res.payment_status === 0) {
                    this.setState({payStatus: false})
                }
                if (res.payment_status === 1) {
                    this.setState({payStatus: true})
                } else if (res.payment_status === 3) {
                    this.setState({payNum: 3}).then(() => {setTimeout(() => {this.setState({payStatus: false})}, 2000)})
                    clearTimeout(timer)
                } else if (res.payment_status === 4) {
                    this.setState({payNum: 4})
                    clearTimeout(timer)
                }
                timer = setTimeout(() => {
                    this.getOrderStatus(id);
                }, 3000)
            }
        })
    }

    closeOrder() {
        const {onClose, onReload} = this.props
        onClose();
        clearTimeout(timer);
        onReload();
    }

    editCode(e){
        this.setState({
            discountCode:e.target.value
        })
    }

    vipMember () {
        ModalClass.open(FullScreen, {
            title: '会员服务协议',
            content: vipmember,
            onClose: ModalClass.pop
        });
    }

    async verifyCode(){
        const { discountCode } = this.state;
        if(!discountCode){
            message.show("请输入渠道码")
            return
        }
        try {
            let vip = await inquiryCode({
                code: discountCode,
            },{quiet: true});
            this.setState({
                vipPrice: vip.price
            })
            this.createOrders(discountCode);
            clearTimeout(timer);
        } catch (error) {
            message.show(error.message);
        }
    }

    render() {
        const {user} = this.props;
        const {goodsInfo, payStatus, payNum,discountCode,vipPrice} = this.state;
        const isVip = user.vip ? user.vip > moment().format("YYYY-MM-DD HH:mm:ss") ? true : false : false;
        const url = `https://www.xiaoaoai.com/h5/pay/index.html?id=${goodsInfo.no && goodsInfo.no}&title=${encodeURIComponent(goodsInfo.goods_title && goodsInfo.goods_title)}&pay=${vipPrice}&name=${encodeURIComponent(user && user.name)}`

        return (
            <ReactModal
                overlayClassName={styles.overlay}
                className={styles.content}
                isOpen={true}
                closeTimeoutMS={400}
            >
                {payStatus ? (
                    <div className={styles.boxs}>
                        <div className={styles.closeBtn} style={{float: 'right'}} onClick={() => this.closeOrder()}>X</div>
                        <div className={styles.paying}><img src={phone}></img></div>
                        <div className={styles.payTips}>{payNum === 3 ? '支付成功' : '请在手机上完成支付'}</div>
                        {payNum !== 3 ? (
                            // <div className={styles.payBtn}><button onClick={() => this.closeOrder()}>已完成支付</button></div>
                            <span className={styles.loading}></span>
                        ) : (null)}
                    </div>
                ) : (
                    <div className={styles.boxs}>
                        <div className={styles.title}>
                            <div className={styles.userContent}>
                                <img className={isVip ? styles.isVip : null} src={window.config.staticURL + '/avatar/' + (user.avatar || 'default.png')}></img>
                                <div>
                                    {
                                        isVip ? (
                                            <span className={isVip ? styles.isVip : null}>{user.name}<img src={vipImg}></img></span>
                                        ) : (
                                            <span>{user.name}</span>
                                        )
                                    }
                                    <p>{isVip ? `您已是VIP会员，会员身份将于${user.vip}过期` : `您还不是VIP会员`}</p>
                                </div>
                            </div>
                            <span className={styles.closeBtn} onClick={() => this.closeOrder()}>X</span>
                        </div>

                        <div className={styles.vipContent}>
                            <span>{goodsInfo.goods_title}</span>
                            <div className={styles.money}><span>￥</span>{vipPrice}</div>
                            <p><img src={gou} />{isVip ? '续费会员' : '开通会员'}</p>
                        </div>

                        <div className={styles.discountBox}>
                            <span>渠道优惠码</span>
                            <input defaultValue={discountCode} onChange={e=>this.editCode(e)}></input>
                            <button onClick={()=>this.verifyCode()}>验证</button>
                        </div>

                        <div className={styles.payContent}>
                            <div className={styles.qrcode}>
                                <QRcode value={url}></QRcode>
                                {/* <QRcode value={`https://dev.scratch-edu.com/h5/pay/index.html`}></QRcode> */}
                            </div>
                            <div className={styles.payWay}>
                                <span>扫码支付</span>
                                <p><img src={wxpay} />微信支付</p>
                                <div className={styles.money}><span>￥</span>{vipPrice}</div>
                            </div>
                        </div>
                        <div className={styles.vipMember} onClick={()=>this.vipMember()}>《会员服务协议》</div>
                    </div>
                )
                }

            </ReactModal>
        )
    }
}


const renderVipModal = ({user, onClose, onReload, setUser}) => {
    return (
        <VipModal
            onClose={onClose}
            user={user}
            onReload={onReload}
            setUser={setUser}
        />
    );
};

export default renderVipModal;
